export const DEFAULT_TICKET_CATEGORY_BUTTON = {
    customer_categoryid: 0,
    name: 'basic',
}
